import React from 'react';

import { Filter } from '@gogame/filters';

import {
  FILTER_BUSINESS_PARTNERS,
  FILTER_SHOW,
} from 'scenes/Users/PartnerUsers/constants';
import { loadBusinessPartners } from 'scenes/Users/PartnerUsers/sources/fields';

export const BusinessPartners = (props) => {
  return (
    <Filter.MultiSelect
      title={'Business partners'}
      name={FILTER_BUSINESS_PARTNERS}
      source={loadBusinessPartners}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Show = (props) => {
  const source = async () => {
    return [
      {
        id: true,
        name: 'All',
      },
      {
        id: false,
        name: 'Only Active',
      },
    ];
  };
  return (
    <Filter.Select
      title={'Show'}
      name={FILTER_SHOW}
      source={source}
      placeholder={'All'}
      maxDate={new Date()}
      {...props}
    />
  );
};
